import { map } from "lodash"
import { NonEmptyArray } from "ts-essentials"
import { descriptorValidator } from "./helpers"

/* Types */
export type SingleStringOperatorType = "eq" | "neq"
export type MultiStringOperatorType = "in" | "notIn"
export type StringDataType = "singleSelect" | "multiSelect"

/* Formatters */
function singleStringFormatter(id: string, operator: SingleStringOperatorType, dataType: "singleSelect", ...values: [{ value: string }]) {
  return {
    [operator]: values[0].value,
  }
}

function multiStringFormatter(id: string, operator: MultiStringOperatorType, dataType: "multiSelect", ...values: NonEmptyArray<{ value: string }>) {
  return {
    [operator]: map(values, ({ value }) => value),
  }
}

/* Operators */
interface SingleStringOperator {
  label: string
  value: SingleStringOperatorType
  queryFormatter: typeof singleStringFormatter
  validator: typeof descriptorValidator
  selectorType: "singleSelect"
}

interface MultiStringOperator {
  label: string
  value: MultiStringOperatorType
  queryFormatter: typeof multiStringFormatter
  validator: typeof descriptorValidator
  selectorType: "multiSelect"
}

export const STRING_OPERATORS: NonEmptyArray<SingleStringOperator | MultiStringOperator> = [{
  label: "is",
  value: "eq",
  queryFormatter: singleStringFormatter,
  selectorType: "singleSelect",
  validator: descriptorValidator,
}, {
  label: "is not",
  value: "neq",
  queryFormatter: singleStringFormatter,
  selectorType: "singleSelect",
  validator: descriptorValidator,
}, {
  label: "is in",
  value: "in",
  queryFormatter: multiStringFormatter,
  selectorType: "multiSelect",
  validator: descriptorValidator,
}, {
  label: "is not in",
  value: "notIn",
  queryFormatter: multiStringFormatter,
  selectorType: "multiSelect",
  validator: descriptorValidator,
}] as const
